import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { CommissionIcon } from '@repo/ui/icons'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

import { getOlCommission } from '../../api/ols/commissions/get-ol-commission'
import { updateOlCommission } from '../../api/ols/commissions/update-ol-commission'
import { ItemNotFound } from '../../components/elements/item-not-found'
import LoadingScreen from '../../components/elements/loading/loading-screen'
import UserNavBar from '../../components/elements/nav-bar'
import OlCommissionForm from '../../components/pages/ols/ol-commissions/ol-commission-form'
import { mapOlCommissionToInput } from '../../components/pages/ols/utils'
import { Paths } from '../../lib/constants/path'
import { updateButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'
import NotFoundPage from '../common/not-found'

const OlCommissionUpdatePage = () => {
  const { id } = useParams<{ id: string }>()
  const { navigate, back } = useNavigator()
  const queryClient = useQueryClient()

  if (!id || isNaN(+id)) return <ItemNotFound title="Identifiant de commission invalide" />

  const { data: olCommission, isPending } = useQuery({
    queryKey: ['ol-commission', id],
    queryFn: () => getOlCommission(+id)
  })

  const { mutateAsync } = useMutation({
    mutationFn: updateOlCommission,
    onError: showAxiosError,
    onSuccess() {
      queryClient.invalidateQueries({ exact: true, queryKey: ['ol-commission', id] })
      toast.success('Fees modifiée avec succès')
    }
  })

  if (isPending) return <LoadingScreen />
  if (!olCommission) return <NotFoundPage />

  return (
    <div>
      <UserNavBar title={'Modifier la fees / avance / retainer'} icon={CommissionIcon} />
      <div className={'h-4'} />

      <Box>
        <OlCommissionForm
          mode="normal"
          title="Fees"
          defaultValues={mapOlCommissionToInput(olCommission)}
          buttonsConfig={updateButtonsConfig({
            onCancel: () => back(Paths.OL_COMMISSIONS_LIST_PAGE),
            onUpdate: (values) => mutateAsync({ id: +id, ...values }),
            onUpdateThenCreate: async (values) => {
              await mutateAsync({ id: +id, ...values })
              navigate(Paths.OL_COMMISSION_CREATE_PAGE)
            },
            onUpdateThenList: async (values) => {
              await mutateAsync({ id: +id, ...values })
              back(Paths.OL_COMMISSIONS_LIST_PAGE)
            }
          })}
        />
      </Box>
    </div>
  )
}

export default OlCommissionUpdatePage
